import { apiClient } from '@/api/client';

// Strata invoicing (Loop 15). Every write carries the version it read (schedule_version / version); stale → 409 {stale}.
const data = (r) => r.data;
const J = (jobId) => `/jobs/${jobId}/ledger/invoicing`;
const I = '/estimating/invoices';
export const getJobInvoicing = (jobId) => apiClient.get(J(jobId)).then(data);
export const setJobSchedule = (jobId, body) => apiClient.put(`${J(jobId)}/schedule`, body).then(data);
export const raiseMilestoneInvoice = (jobId, milestoneId, body) =>
  apiClient.post(`${J(jobId)}/milestones/${milestoneId}/raise`, body).then(data);
// A3: T&M (unbilled costs) and progress (contract × % complete) invoices, alongside the milestones.
export const raiseTmInvoice = (jobId, body) => apiClient.post(`${J(jobId)}/tm`, body).then(data);
export const raiseProgressInvoice = (jobId, body) => apiClient.post(`${J(jobId)}/progress`, body).then(data);
export const getJobInvoicingHistory = (jobId) => apiClient.get(`${J(jobId)}/history`).then(data);

export const listInvoices = (params) => apiClient.get(I, { params }).then(data);
export const getInvoice = (id) => apiClient.get(`${I}/${id}`).then(data);
export const patchInvoice = (id, body) => apiClient.patch(`${I}/${id}`, body).then(data);
export const sendInvoice = (id, body) => apiClient.post(`${I}/${id}/send`, body).then(data);
export const newInvoiceLink = (id, body) => apiClient.post(`${I}/${id}/link`, body).then(data);
export const revokeInvoiceLink = (id, body) => apiClient.post(`${I}/${id}/link/revoke`, body).then(data);
export const voidInvoice = (id, body) => apiClient.post(`${I}/${id}/void`, body).then(data);
export const recordInvoicePayment = (id, body) => apiClient.post(`${I}/${id}/payments`, body).then(data);
export const retryInvoiceQbo = (id) => apiClient.post(`${I}/${id}/qbo/retry`, null, { timeout: 90000 }).then(data);
// Step 3: pay online through QuickBooks Payments + overdue reminders.
export const turnOnPayOnline = (id) => apiClient.post(`${I}/${id}/pay-online`, null, { timeout: 90000 }).then(data);
export const confirmOnlinePayment = (id, pendingId, body) => apiClient.post(`${I}/${id}/pending/${pendingId}/confirm`, body).then(data);
export const dismissOnlinePayment = (id, pendingId, body) => apiClient.post(`${I}/${id}/pending/${pendingId}/dismiss`, body).then(data);
export const setInvoiceReminders = (id, body) => apiClient.put(`${I}/${id}/reminders`, body).then(data);
export const getReminderDraft = (id) => apiClient.get(`${I}/${id}/reminder-draft`).then(data);
export const sendInvoiceReminder = (id, body) => apiClient.post(`${I}/${id}/remind`, body, { timeout: 60000 }).then(data);
// Step 4: change-order credits on a Draft (no amount = as much as fits), and the job's contract history.
export const applyInvoiceCredit = (id, body) => apiClient.post(`${I}/${id}/credits`, body).then(data);
export const removeInvoiceCredit = (id, creditId, body) => apiClient.post(`${I}/${id}/credits/${creditId}/remove`, body).then(data);
export const getContractHistory = (jobId) => apiClient.get(`/jobs/${jobId}/ledger/contract-history`).then(data);
export async function openInvoicePdf(id) {
  const res = await apiClient.get(`${I}/${id}/pdf`, { responseType: 'blob', timeout: 60000 });
  const url = URL.createObjectURL(res.data);
  window.open(url, '_blank', 'noopener');
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export const getInvoiceSettings = () => apiClient.get('/estimating/invoice-settings').then(data);
export const saveInvoiceSettings = (body) => apiClient.put('/estimating/invoice-settings', body).then(data);

// The client's private link (no login).
export const getPublicInvoice = (token) => apiClient.get(`/invoice-link/${encodeURIComponent(token)}`).then(data);
export const publicInvoicePdfUrl = (token) =>
  `${process.env.REACT_APP_BACKEND_URL}/api/invoice-link/${encodeURIComponent(token)}/pdf`;
